import { useNavigate } from 'react-router-dom';
import './../../components/common/FormBox/formBox.css';
import Questionaire from '../assessmentPage/Questionnaire/Questionnaire';
import { Fab } from '@mui/material';
import { Edit } from '@mui/icons-material';

export default function ServiceProviderOverview() {
    const navigate = useNavigate();
    window.scrollTo(0, 0);
    return (
        <div
            style={{
                maxWidth: '1256px',
                minHeight: '100vh',
                margin: 'auto',
                marginTop: '150px',

                backgroundColor: 'white',
                padding: '20px',
                paddingTop: '5px',
            }}
        >
            <div style={{ marginLeft: '334px', marginTop: '32px', display: 'flex' }}>
                <h1 className="mr-5">Company Profile</h1>
                <div className="card questionaire">
                    <Fab
                        sx={[
                            {
                                color: '#4A52BB',
                                border: '1px solid #4A52BB',
                                backgroundColor: 'white',
                            },
                            (theme) => ({
                                '&:hover': {
                                    backgroundColor: '#4A52BB !important',
                                    color: 'white',
                                    border: 'unset',
                                },
                            }),
                        ]}
                        size="small"
                        aria-label="edit"
                        onClick={() => navigate('/register_service_provider')}
                    >
                        <Edit />
                    </Fab>
                </div>
            </div>

            <Questionaire />
        </div>
    );
}
